import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { categories, articles, faqs } from '@/mocks/data';

export default function StructuredData() {
  const location = useLocation();

  useEffect(() => {
    const scripts = document.querySelectorAll('script[data-schema]');
    scripts.forEach((s) => s.remove());

    const injectScript = (json: object) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-schema', 'true');
      script.textContent = JSON.stringify(json, null, 2);
      document.head.appendChild(script);
    };

    // Organization
    injectScript({
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '羁绊创作工坊',
      description: '专注姐妹情感羁绊创作，为写作者与角色扮演爱好者提供深度指南与灵感。',
      url: 'https://readdy.ai/',
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        email: 'contact@jibanstudio.com',
      },
    });

    // WebSite
    injectScript({
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '羁绊创作工坊',
      url: 'https://readdy.ai/',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://readdy.ai/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    });

    // WebPage
    const pageName =
      location.pathname === '/' ? '首页' :
      location.pathname.startsWith('/category/') ? '分类页' :
      location.pathname.startsWith('/article/') ? '文章页' :
      location.pathname === '/about' ? '关于我们' : '页面';

    injectScript({
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: pageName,
      url: `https://readdy.ai${location.pathname}`,
    });

    // BreadcrumbList for category/article pages
    if (location.pathname.startsWith('/category/')) {
      const cat = categories.find((c) => c.slug === location.pathname.split('/').pop());
      if (cat) {
        injectScript({
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: '首页', item: 'https://readdy.ai/' },
            { '@type': 'ListItem', position: 2, name: cat.name, item: `https://readdy.ai/category/${cat.slug}` },
          ],
        });
      }
    }

    if (location.pathname.startsWith('/article/')) {
      const article = articles.find((a) => a.slug === location.pathname.split('/').pop());
      if (article) {
        // Breadcrumb
        injectScript({
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: '首页', item: 'https://readdy.ai/' },
            { '@type': 'ListItem', position: 2, name: article.categoryName, item: `https://readdy.ai/category/${article.categorySlug}` },
            { '@type': 'ListItem', position: 3, name: article.title, item: `https://readdy.ai/article/${article.slug}` },
          ],
        });

        // Article
        injectScript({
          '@context': 'https://schema.org',
          '@type': 'Article',
          headline: article.title,
          description: article.excerpt,
          image: article.coverImage,
          author: {
            '@type': 'Person',
            name: article.author,
          },
          datePublished: article.publishDate,
          publisher: {
            '@type': 'Organization',
            name: '羁绊创作工坊',
          },
          url: `https://readdy.ai/article/${article.slug}`,
        });
      }
    }

    // FAQPage for homepage
    if (location.pathname === '/') {
      injectScript({
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqs.map((faq) => ({
          '@type': 'Question',
          name: faq.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: faq.answer,
          },
        })),
      });
    }

    // About page
    if (location.pathname === '/about') {
      injectScript({
        '@context': 'https://schema.org',
        '@type': 'AboutPage',
        name: '关于羁绊创作工坊',
        description: '羁绊创作工坊是一个专注于姐妹情感羁绊创作的文字社区，致力于为写作者与角色扮演爱好者提供深度指南。',
        url: 'https://readdy.ai/about',
      });
    }
  }, [location.pathname]);

  return null;
}